
import { AppConfig } from './app.config';
import { Injectable } from '@angular/core';

export function InitJsonConfig(config: JsonConfig) {
  return async () => await config.load();
}

@Injectable({ providedIn: 'root' })
export class JsonConfig extends AppConfig {

  async load() {

    try {
      const response = await fetch('appsettings.json');
      const value: AppConfig = await response.json();

      this.authTokenKey = value.authTokenKey;
      this.urlApi = value.urlApi;
      this.oauth = value.oauth;
      this.urlOldAfs = value.urlOldAfs;
      this.versionApi = value.versionApi;
      this.version = value.version;

      const devInfoCSS = 'font-size:25px; font-family: "Oswald", sans-serif; color: black;';
      // tslint:disable-next-line: no-console
      console.info('%cIA%cTec %c</> %cdeveloping with passion', devInfoCSS, devInfoCSS + 'color: #1189CA;', 'color: black;', 'color: gray; font-family: arial, tahoma, verdana;');
      // tslint:disable-next-line: no-console

    } catch (e) {
      console.log('[ERROR] Could not load "appsettings.json"');
      console.log(e);
    }

  }
}
